// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"99322243","448":"380e379f","702":"ccf23f8e","728":"97b27257","878":"ee5b7627","986":"a5b2dbc5"}[chunkId] + ".chunk.js";
};